import React from 'react';
import styled from 'styled-components';
import { useTranslation } from '../utils/translation';

const Wrapper = styled.div`
  background: var(--color-alt-4);
  border-radius: 6px;
  border: solid 1px #ddd;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: var(--spacer);
`;

const CheckList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: var(--spacer-xs);
  margin: 0 0 var(--spacer-s);
  text-align: left;
  width: 80%;
  list-style: none;

  svg {
    margin-right: 9px;
    position: relative;
    top: 3px;
  }

  li {
    color: var(--text-color);
    font-size: 22px;
    font-weight: bold;
  }
`;

const List = styled.li`
  margin-top: 5px;
`;
const Description = styled.div`
  font-size: 18px;
  line-height: 1.5em;
`;

export function Reassurance() {
  const t = useTranslation();

  return (
    <Wrapper>
      <CheckList>
        <List>
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9.82921 14.8651C9.73372 14.9517 9.60352 15 9.46822 15C9.33291 15 9.20271 14.9517 9.10722 14.8651L6.22441 12.2658C5.9252 11.9961 5.9252 11.5588 6.22441 11.2895L6.5854 10.9641C6.88461 10.6944 7.36916 10.6944 7.66837 10.9641L9.46822 12.5867L14.3316 8.2023C14.6308 7.93257 15.1159 7.93257 15.4146 8.2023L15.7756 8.52773C16.0748 8.79747 16.0748 9.23475 15.7756 9.50403L9.82921 14.8651Z"
              fill="#FF0037"
            />
            <circle cx="11" cy="11" r="10" stroke="#FF0037" strokeWidth="2" />
          </svg>
          {t('design.reassurance.top1')}
        </List>
        <List>
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9.82921 14.8651C9.73372 14.9517 9.60352 15 9.46822 15C9.33291 15 9.20271 14.9517 9.10722 14.8651L6.22441 12.2658C5.9252 11.9961 5.9252 11.5588 6.22441 11.2895L6.5854 10.9641C6.88461 10.6944 7.36916 10.6944 7.66837 10.9641L9.46822 12.5867L14.3316 8.2023C14.6308 7.93257 15.1159 7.93257 15.4146 8.2023L15.7756 8.52773C16.0748 8.79747 16.0748 9.23475 15.7756 9.50403L9.82921 14.8651Z"
              fill="#FF0037"
            />
            <circle cx="11" cy="11" r="10" stroke="#FF0037" strokeWidth="2" />
          </svg>
          {t('design.reassurance.top2')}
        </List>
        <List>
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9.82921 14.8651C9.73372 14.9517 9.60352 15 9.46822 15C9.33291 15 9.20271 14.9517 9.10722 14.8651L6.22441 12.2658C5.9252 11.9961 5.9252 11.5588 6.22441 11.2895L6.5854 10.9641C6.88461 10.6944 7.36916 10.6944 7.66837 10.9641L9.46822 12.5867L14.3316 8.2023C14.6308 7.93257 15.1159 7.93257 15.4146 8.2023L15.7756 8.52773C16.0748 8.79747 16.0748 9.23475 15.7756 9.50403L9.82921 14.8651Z"
              fill="#FF0037"
            />
            <circle cx="11" cy="11" r="10" stroke="#FF0037" strokeWidth="2" />
          </svg>
          {t('design.reassurance.top3')}
        </List>
      </CheckList>
      <Description>
        {t('design.reassurance.description')} <b>{t('design.reassurance.descriptionB')}</b>
      </Description>
    </Wrapper>
  );
}
